<template>
  <div class="view-design-content" v-if="value">
    <!-- Si hay un diseño guardado, lo mostramos -->
    <template v-if="view && view.design && view.design.containers">
      <div
        v-for="(container, containerIndex) in view.design.containers"
        :key="containerIndex"
        :class="container.classes"
        :style="getContainerStyle(container)"
      >
        <!-- Contenedor vertical -->
        <div v-if="container.viewId">
          <ViewDesignContent
            v-if="referenceViews[container.viewId]"
            :view="referenceViews[container.viewId]"
            :fields="referenceFields[container.viewId] || []"
            :value="value"
            :visualGroups="visualGroups"
            :lists="lists"
            :models="models"
            :selectedModel="selectedModel"
          />
          <div v-else class="text-muted">Cargando vista...</div>
        </div>
        <div
          v-else-if="container.layout === 'vertical'"
          class="d-flex flex-column"
        >
          <div
            v-for="field in container.fields || []"
            :key="typeof field === 'string' ? field : field.key"
            class="field-item"
          >
            <template
              v-if="getField(typeof field === 'string' ? field : field.key)"
            >
              <small
                class="form-label w-100"
                v-if="
                  typeof field === 'object' ? field.showLabel !== false : true
                "
              >
                <strong>{{
                  getField(typeof field === "string" ? field : field.key).label
                }}</strong>
              </small>
              <div class="field-value">
                <template v-if="typeof field === 'string'">
                  <template v-if="getField(field).type === 'group'">
                    <ViewGroupField
                      :fields="getField(field).fields"
                      :value="value[field] || {}"
                      :lists="lists"
                      :models="models"
                    />
                  </template>
                  <template v-else>
                    {{ getFieldValue(getField(field)) }}
                  </template>
                </template>
                <template v-else>
                  <template
                    v-if="
                      field.type === 'reference' && field.renderAs === 'view'
                    "
                  >
                    <ViewDesignContent
                      v-if="field.viewId && referenceViews[field.viewId]"
                      :view="referenceViews[field.viewId]"
                      :fields="referenceFields[field.viewId] || []"
                      :value="getReferenceValue(field.key)"
                      :visualGroups="visualGroups"
                      :lists="lists"
                      :models="models"
                      :selectedModel="selectedModel"
                    />
                    <div v-else class="text-muted">Cargando vista...</div>
                  </template>
                  <template
                    v-else-if="field.type === 'group' && !field.isArray"
                  >
                    <ViewGroupField
                      :fields="field.fields"
                      :value="value[field.key] || {}"
                      :lists="lists"
                      :models="models"
                    />
                  </template>
                  <template v-else-if="field.type === 'group' && field.isArray">
                    <ViewGroupFieldTable
                      v-for="(value, index) in value[field.key]"
                      :key="index"
                      :fields="field.fields"
                      :value="value || {}"
                      :index="index"
                      :lists="lists"
                      :models="models"
                    />
                  </template>
                  <template v-else-if="getField(field.key).type === 'group'">
                    <ViewGroupField
                      :fields="getField(field.key).fields"
                      :value="value[field.key] || {}"
                      :lists="lists"
                      :models="models"
                    />
                  </template>
                  <template v-else>
                    {{ getFieldValue(getField(field.key)) }}
                  </template>
                </template>
              </div>
            </template>
          </div>
        </div>

        <!-- Contenedor horizontal -->
        <div
          v-else-if="container.layout === 'horizontal'"
          class="d-flex flex-row"
        >
          <div
            v-for="field in container.fields || []"
            :key="typeof field === 'string' ? field : field.key"
            class="field-item"
          >
            <template
              v-if="getField(typeof field === 'string' ? field : field.key)"
            >
              <small
                class="form-label w-100"
                v-if="
                  typeof field === 'object' ? field.showLabel !== false : true
                "
              >
                <strong>{{
                  getField(typeof field === "string" ? field : field.key).label
                }}</strong>
              </small>
              <div class="field-value">
                <template v-if="typeof field === 'string'">
                  <template v-if="getField(field).type === 'group'">
                    <ViewGroupField
                      :fields="getField(field).fields"
                      :value="value[field] || {}"
                      :lists="lists"
                      :models="models"
                    />
                  </template>
                  <template v-else>
                    {{ getFieldValue(getField(field)) }}
                  </template>
                </template>
                <template v-else>
                  <template
                    v-if="
                      field.type === 'reference' && field.renderAs === 'view'
                    "
                  >
                    <ViewDesignContent
                      v-if="field.viewId && referenceViews[field.viewId]"
                      :view="referenceViews[field.viewId]"
                      :fields="referenceFields[field.viewId] || []"
                      :value="getReferenceValue(field.key)"
                      :visualGroups="visualGroups"
                      :lists="lists"
                      :models="models"
                      :selectedModel="selectedModel"
                    />
                    <div v-else class="text-muted">Cargando vista...</div>
                  </template>
                  <template v-else-if="field.type === 'group'">
                    <ViewGroupField
                      :fields="field.fields"
                      :value="value[field.key] || {}"
                      :lists="lists"
                      :models="models"
                    />
                  </template>
                  <template v-else>
                    {{ getFieldValue(getField(field.key)) }}
                  </template>
                </template>
              </div>
            </template>
          </div>
        </div>

        <!-- Contenedor grid -->
        <div v-else-if="container.layout === 'grid'" class="d-grid">
          <div
            v-for="field in container.fields || []"
            :key="typeof field === 'string' ? field : field.key"
            class="field-item"
          >
            <template
              v-if="getField(typeof field === 'string' ? field : field.key)"
            >
              <small
                class="form-label w-100"
                v-if="
                  typeof field === 'object' ? field.showLabel !== false : true
                "
              >
                <strong>{{
                  getField(typeof field === "string" ? field : field.key).label
                }}</strong>
              </small>
              <div class="field-value">
                <template v-if="typeof field === 'string'">
                  <template v-if="getField(field).type === 'group'">
                    <ViewGroupField
                      :fields="getField(field).fields"
                      :value="value[field] || {}"
                      :lists="lists"
                      :models="models"
                    />
                  </template>
                  <template v-else>
                    {{ getFieldValue(getField(field)) }}
                  </template>
                </template>
                <template v-else>
                  <template
                    v-if="
                      field.type === 'reference' && field.renderAs === 'view'
                    "
                  >
                    <ViewDesignContent
                      v-if="field.viewId && referenceViews[field.viewId]"
                      :view="referenceViews[field.viewId]"
                      :fields="referenceFields[field.viewId] || []"
                      :value="getReferenceValue(field.key)"
                      :visualGroups="visualGroups"
                      :lists="lists"
                      :models="models"
                      :selectedModel="selectedModel"
                    />
                    <div v-else class="text-muted">Cargando vista...</div>
                  </template>
                  <template v-else-if="field.type === 'group'">
                    <ViewGroupField
                      :fields="field.fields"
                      :value="value[field.key] || {}"
                      :lists="lists"
                      :models="models"
                    />
                  </template>
                  <template v-else>
                    {{ getFieldValue(getField(field.key)) }}
                  </template>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>

    <!-- Si no hay diseño, mostramos la vista por defecto -->
    <ViewContent
      v-else
      :fields="fields"
      :value="value"
      :visualGroups="visualGroups"
      :lists="lists"
      :models="models"
      :selectedModel="selectedModel"
    />
  </div>
</template>

<script>
import ViewContent from "./ViewContent.vue";
import ViewGroupField from "./ViewGroupField.vue";
import ViewGroupFieldTable from "./ViewGroupFieldTable.vue";
import FileDisplay from "./FileDisplay.vue";
import { wencesApi } from "@/api/wencesApi";
import { formatNumberSync } from "@/utils/numberFormatter";

export default {
  name: "ViewDesignContent",
  components: {
    ViewContent,
    ViewGroupField,
    ViewGroupFieldTable,
    FileDisplay,
  },
  props: {
    view: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    visualGroups: {
      type: Array,
      default: () => [],
    },
    lists: {
      type: Array,
      default: () => [],
    },
    models: {
      type: Array,
      default: () => [],
    },
    selectedModel: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      referenceOptions: {},
      referenceViews: {},
      referenceFields: {},
      isLoading: true,
    };
  },
  mounted() {
    this.initializeData();
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.initializeData();
        }
      },
      deep: true,
    },
    view: {
      handler(newView) {
        if (newView) {
          this.initializeData();
        }
      },
      immediate: true,
    },
    fields: {
      handler(newFields) {
        if (newFields) {
          this.initializeData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async initializeData() {
      this.isLoading = true;
      try {
        await Promise.all([
          this.loadAllReferenceOptions(),
          this.loadReferenceViews(),
        ]);
      } catch (error) {
        console.error("Error initializing data:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async loadAllReferenceOptions() {
      if (!this.fields || !this.fields.length) {
        return;
      }

      for (const field of this.fields) {
        if (field.type === "reference" && field.ref) {
          try {
            const { data } = await wencesApi.get(
              `/api/gotrading/dynamic/${field.ref}`
            );
            this.$set(this.referenceOptions, field.key, data);
          } catch (error) {
            console.error(
              `Error loading reference options for ${field.key}:`,
              error
            );
            this.$set(this.referenceOptions, field.key, []);
          }
        }
      }
    },
    async loadReferenceViews() {
      if (!this.view || !this.view.design || !this.view.design.containers) {
        return;
      }

      // Obtener todos los campos de referencia con vista
      const referenceFields = [];
      const viewContainers = [];

      this.view.design.containers.forEach((container) => {
        // Verificar campos de referencia con vista
        if (container.fields && Array.isArray(container.fields)) {
          container.fields.forEach((field) => {
            if (
              typeof field === "object" &&
              field.type === "reference" &&
              field.renderAs === "view" &&
              field.viewId
            ) {
              referenceFields.push(field);
            }
          });
        }

        // Verificar contenedores con vista
        if (container.viewId) {
          viewContainers.push(container);
        }
      });

      // Cargar las vistas y sus campos
      const allViewIds = [
        ...referenceFields.map((field) => field.viewId),
        ...viewContainers.map((container) => container.viewId),
      ];

      for (const viewId of allViewIds) {
        try {
          const { data: viewData } = await wencesApi.get(
            `/api/gotrading/views/${viewId}`
          );
          if (!viewData) {
            continue;
          }

          this.$set(this.referenceViews, viewId, viewData);

          // Cargar los campos de la vista
          const { data: fieldsData } = await wencesApi.get(
            `/api/gotrading/model-definitions/${viewData.modelName}`
          );
          this.$set(this.referenceFields, viewId, fieldsData?.fields || []);
        } catch (error) {
          console.error(
            `Error loading reference view for viewId ${viewId}:`,
            error
          );
        }
      }
    },
    getContainerStyle(container) {},
    getField(fieldKey) {
      return this.fields.find((f) => f.key === fieldKey);
    },
    getFieldValue(field) {
      if (!field || !this.value) return "";

      const value = this.value[field.key];

      // Campo tipo fecha
      if (field.type === "date" && value) {
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        }
      }

      // Campo tipo lista
      if (field.type === "list") {
        // Si es una lista múltiple
        if (field.isArray && Array.isArray(value)) {
          return value.map((v) => this.getListOptionLabel(field, v)).join(", ");
        }

        // Si es una lista simple
        return this.getListOptionLabel(field, value);
      }

      // Campo tipo referencia
      if (field.type === "reference") {
        const refModel = this.models.find((m) => m.modelName === field.ref);
        if (refModel && value) {
          // Si el valor es un objeto con _id, buscar en referenceOptions
          if (typeof value === "object" && value._id) {
            const refOptions = this.referenceOptions[field.key];
            if (refOptions) {
              const refItem = refOptions.find((item) => item._id === value._id);
              return refItem
                ? refItem.name || refItem.label || refItem._id
                : value._id;
            }
          }
          // Si el valor es un string (el _id), buscar en referenceOptions
          else if (typeof value === "string") {
            const refOptions = this.referenceOptions[field.key];
            if (refOptions) {
              const refItem = refOptions.find((item) => item._id === value);
              return refItem
                ? refItem.name || refItem.label || refItem._id
                : value;
            }
          }
          return value;
        }
      }

      // Campo tipo grupo
      if (field.type === "group") {
        return value ? JSON.stringify(value) : "";
      }

      // Campo tipo array
      if (field.type === "array") {
        return Array.isArray(value) ? value.join(", ") : "";
      }

      // Campo tipo imagen
      if (field.type === "image") {
        if (Array.isArray(value)) {
          return value.length > 0 ? `${value.length} imagen(es)` : "Sin imagen";
        }
        return value ? "Imagen seleccionada" : "Sin imagen";
      }

      // Campo tipo select
      if (
        field.type === "select" &&
        field.options &&
        Array.isArray(field.options)
      ) {
        const option = field.options.find((opt) => opt.value === value);
        return option ? option.label : value;
      }

      // Campo tipo archivo
      if (field.type === "file") {
        return `<FileDisplay :value="${value}" />`;
      }

      // Campo tipo número con formato de moneda
      if (
        field.type === "number" &&
        field.currency &&
        value !== null &&
        value !== undefined &&
        value !== ""
      ) {
        const numValue = typeof value === "string" ? parseFloat(value) : value;
        if (!isNaN(numValue)) {
          let formattedValue = formatNumberSync(numValue);

          // Agregar símbolo de moneda si está definido
          if (
            field.currencyField &&
            this.value &&
            this.value[field.currencyField]
          ) {
            formattedValue += ` ${this.value[field.currencyField]}`;
          }

          return formattedValue;
        }
      }

      return value;
    },
    getReferenceValue(fieldKey) {
      const value = this.value[fieldKey];
      if (!value) return null;

      // Si el valor es un string (ID), buscar en referenceOptions
      if (typeof value === "string") {
        const refOptions = this.referenceOptions[fieldKey];
        if (refOptions) {
          return (
            refOptions.find((item) => item._id === value) || { _id: value }
          );
        }
      }

      // Si el valor es un objeto, devolverlo directamente
      return value;
    },
    getListOptionLabel(field, value) {
      if (!value) return "";

      // Si el valor es un objeto con _id, usar el _id
      const id = typeof value === "object" && value._id ? value._id : value;

      // Buscar en los listados disponibles
      const list = this.lists?.find((l) => l.type === field.listType);
      if (!list || !list.values) return id;

      // Buscar el valor en la lista
      const option = list.values.find((opt) => opt._id === id);
      return option ? option.label : id;
    },
  },
};
</script>
